@let viewModel = viewModel$ | async;

<re-spinner [showOverlay]="true" [spinner]="spinner" />

@if (videoFeatureEnabled()) {
<lc-upload-video [photoOrderId]="viewModel?.photoOrder?._id" [subTitle]="videoSubTitle()" [title]="videoTitle()"
  [videoSubmitted]="videoSubmitted()" [videoTips]="videoTips()" [(video)]="video" />

@if (video() && !videoSubmitted()) {
<div class="fx-row x-end">
  <button color="primary" id="multimediaitem-submit-video" lcTestId="multimediaitem-submit-video" mat-raised-button
    type="button" (click)="submitVideo(viewModel)">
    Submit Video
  </button>
</div>
}

<hr class="my-4">
}

<h4>Add Multimedia Link</h4>

<div class="fx-row fx-gap-sm pb-lg">
  <mat-icon>tips_and_updates</mat-icon>
  <div>
    <strong>If submitting a link that will be used for YouTube advertising:</strong>
    <ul class="m-0 pl-md">
      @for (tip of videoLinkTips(); track $index) {
      <li>{{ tip }}</li>
      }
    </ul>
  </div>
</div>

<lc-multi-media-item-form idPrefix="add" [formGroup]="addFormGroup" />

<div class="fx-row x-end">
  <button color="primary" id="multimediaitem-add-link" lcTestId="multimediaitem-add-link" mat-raised-button
    type="button" [disabled]="!addFormGroup.valid" (click)="addLink(viewModel)">
    Submit Multimedia
  </button>
</div>

<lc-multimedia-table deleteEnabled="false" editEnabled="false" selectEnabled="false"
  [items]="viewModel?.multimediaLinks" />